import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import {
  BuildingMultiSelect,
  BuildingSelectFormikField,
} from '../../../../Building'
import { PROVIDER_FORM_FIELD_NAME_BUILDING } from '../../ProviderForm.constants'

import * as styles from './BuildingField.module.css'

function BuildingField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <BuildingSelectFormikField
      multi
      Select={BuildingMultiSelect}
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('Provider.BuildingFieldPlaceholderKey'),
          },
        },
      }}
      fieldComponentProps={{
        label: `${t('Provider.BuildingFieldLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      name={PROVIDER_FORM_FIELD_NAME_BUILDING}
      tagsProps={{
        className: styles.buildingFieldTags,
      }}
    />
  )
}

export default BuildingField
